export class SessionInfoManager {

    public static setSteemAccountName(name: string): void {
        sessionStorage.setItem(SessionInfoManager.steemAccountName, name);
    }

    public static getSteemAccountName(): string {
        return sessionStorage.getItem(SessionInfoManager.steemAccountName);
    }

    public static setSteemConnectToken(token: string): void {
        sessionStorage.setItem(SessionInfoManager.steemConnectToken, token);
    }

    public static getSteemConnectToken(): string {
        return sessionStorage.getItem(SessionInfoManager.steemConnectToken);
    }

    public static setKeychainJWT(token: string): void {
        sessionStorage.setItem(SessionInfoManager.keychainJWT, token);
    }

    public static getKeychainJWT(): string {
        return sessionStorage.getItem(SessionInfoManager.keychainJWT);
    }

    private static readonly steemAccountName = "steemAccountName";
    private static readonly steemConnectToken = "steemConnectToken";
    private static readonly keychainJWT = "keychainJWT";
}



// WEBPACK FOOTER //
// ./src/app/SessionInfoManager.ts